import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { Link } from 'react-router-dom'
import Button from '../components/Button'
import { BlocksRenderer } from '@strapi/blocks-react-renderer'

const TitleTextButton = ({ data, component, shortTitle, title, text, buttons, pdf, sectionColor = "orange", medienSection }) => {
    return (
        <div className={`title-text-button-module ${medienSection ? 'medien-banner-sec' : ''}`}>
            {shortTitle && <div className='subtitle'>{shortTitle}</div>}
            <div className='row eql_col_content'>
                <div className={`${text ? 'col-lg-5' : 'col-12'} title-col`}>
                    {title && <h2 className={`text-black mb-lg-4 mb-2`}>{title}</h2>}
                </div>
                {text && <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                    {text && <BlocksRenderer content={text} />}
                    {medienSection && <div className='info_detail mt-4'>
                        <img src='https://backend.bgzurlinden.ch/uploads/Jasmin_Fuhlbruegge_595768a061.webp' className='dummy_icon' alt='Jasmin Fuhlbrügge' />
                        <div className="infotext">
                            <h4 className="fs_30 fw-600 text-darkgrey mb-1">Jasmin Fuhlbrügge</h4>
                            <small>Kommunikationsverantwortliche</small>
                            <div className='Torsten_kontakt mt-1'>
                                <Link to='mailto: jasmin.fuhlbruegge@bgzurlinden.ch'>
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="20" cy="20" r="19.5" stroke="inherit" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M29.9987 14.5305L23.0731 20.3358L29.9987 26.1411V14.5305ZM29.6527 27.045C29.4597 27.2249 29.2018 27.3359 28.9207 27.3359H10.4101C10.1299 27.3359 9.8729 27.2259 9.68085 27.0478L16.9758 20.9328L18.09 21.8673C18.5289 22.2348 19.1031 22.4175 19.6746 22.4147C20.2452 22.4119 20.8204 22.2254 21.262 21.8542L22.3614 20.9328L29.6527 27.045ZM9.33203 26.1459L16.2643 20.3359L9.33203 14.5258V26.1459ZM9.68088 13.6241C9.87292 13.445 10.1299 13.3359 10.4101 13.3359H28.9207C29.2027 13.3359 29.4606 13.4469 29.6527 13.6269L22.0758 19.9787L22.0656 19.9871L20.6796 21.1491C20.405 21.3794 20.0394 21.4951 19.672 21.4969C19.3056 21.4988 18.9428 21.3869 18.6738 21.1621L17.2729 19.988L17.2608 19.9777L9.68088 13.6241Z" fill="inherit" />
                                    </svg> jasmin.fuhlbruegge@bgzurlinden.ch
                                </Link>
                            </div>
                        </div>
                    </div>}
                    {buttons && <Button component={component} pdf={pdf} buttons={buttons} btnStyle="round_btn" />}

                </div>}
            </div>
        </div>
    )
}

export default TitleTextButton